import { createSlice } from '@reduxjs/toolkit';
import translations from './translations';
import utils from './utils';
import constants from './constants';

const initialState = {
    data: null,
    currentStep: 0,
    selectedOptions: null,
    selectedPackage: null,
    treatmentOptions: null,
    treatmentOptionsPackages: null,
    treatmentStepTitleInGvp: null,
    baseLensPackage: null,
    isExitModalOpen: false,
    isInsuranceEnabled: false,
    isInsuranceLoading: false,
    isInsuranceLogged: null,
    isInsurancePopupOpen: true,
    totalPrice: null,
    totalDiscount: null,
    paymentInstallmentsType: null,
    paymentInstallmentsQuantity: null,
    selectedColorOption: null,
    editColorLens: false,
    firstStep: 0,
    typeLearnMore: null,
    isAddingToCart: false,
    selectedWarranty: null,
    editModeCatEntryId: null,
    editModeWarrantyCatEntryId: null,
    editModeRemoveWarrantyCatEntryId: null,
    extraTreatment: null,
    isLearnMoreModalOpen: false,
    treatmentTypeLearnMore: null,
    treatmentGroupLearnMore: null,
    stepValueSelected: {},
    forceTreatmentType: {},
    espotBackground: null,
    blueLightAlertContent: null,
    currentTreatment: 0,
    currentTreatmentSelected: null,
    isLensGaming: false,
    blueLightGamingAlertContent: null,
    isMade: true,
    espotBackgroundTreatment: null,
    labels: translations['default']['en_US'],
    baseURLs: constants.baseURLs,
    productImage: null,
    fiveSecond: false,
    controlVideo: null,
    percentageProgress: 0,
    learnMoreBackgrounds: null,
    contentOnLoad: null,
    animationInsurance: true,
    isReadyCustomURL: false,
    brandDisclaimer: null,
    blueDisclaimer: null,
    brandSelected: null,
    frameUPC: null,
    resetTotalsOnInit: true,
    fullscreen: false,
    firstLearnMoreTreatmentMobile: {},
    extPrescriptionObject: null,
    selectedPrescriptionObject: null,
    isPrescriptionModalOpen: false,
    isSimplePrescription: null,
    currencyFormat: constants.currencyFormat,
    isPDModalOpen: false,
    pDEspotContent: null,
    prescriptionSidebarEspotContent: null,
    mirrorAlertContent: null,
    tapAndHold: null,
    espotBackgroundTap: null,
    espotBackgroundTreatmentTap: null,
    isMoreOneBrand: false,
    productImageOld: null,
    isPrescriptionFormOpen: false,
    isFrameOnlySelected: false,
    isGVP: false,
    isFirstVideo: true,
    myVideoTime: null,
    imageErrorMessage: false,
    espotBackgroundVideo: null,
    errorLoadImage: false,
    lensErrorMessage: false,
};

const mainSlice = createSlice({
    name: 'main',
    initialState: initialState,
    reducers: {
        setData: (state, action) => {
            state.data = action.payload;
        },
        setSelectedOptions: (state, action) => {
            const selectedOptions = action.payload;

            if (selectedOptions) {
                let tempSelectedOptions = state.selectedOptions;

                if (tempSelectedOptions == null) {
                    tempSelectedOptions = {};
                }

                Object.entries(selectedOptions).forEach(selectedOption => {
                    const key = selectedOption[0];
                    const value = selectedOption[1];

                    tempSelectedOptions[key] = value;
                });

                state.selectedOptions = tempSelectedOptions;
            }
        },
        clearSelectedOptions: (state, action) => {
            const selectedOptions = action.payload;

            if (selectedOptions && Array.isArray(selectedOptions)) {
                let tempSelectedOptions = state.selectedOptions;

                selectedOptions.forEach(selectedOption => {
                    if (tempSelectedOptions[selectedOption]) {
                        delete tempSelectedOptions[selectedOption];
                    }
                });

                if (Object.entries(tempSelectedOptions).length == 0) {
                    tempSelectedOptions = null;
                }

                state.selectedOptions = tempSelectedOptions;
            }
        },
        setSelectedPackage: (state, action) => {
            state.selectedPackage = action.payload;
        },
        clearSelectedPackage: (state, action) => {
            state.selectedPackage = null;
        },
        setTreatmentOptions: (state, action) => {
            state.treatmentOptions = action.payload;
        },
        setTreatmentOptionsPackages: (state, action) => {
            state.treatmentOptionsPackages = action.payload;
        },
        setTreatmentStepTitleInGvp: (state, action) => {
            state.treatmentStepTitleInGvp = action.payload;
        },
        goToStep: (state, action) => {
            state.currentStep = action.payload;
        },
        openExitModal: (state, action) => {
            state.isExitModalOpen = true;
        },
        closeExitModal: (state, action) => {
            state.isExitModalOpen = false;
        },
        setInsuranceEnabled: (state, action) => {
            state.isInsuranceEnabled = action.payload;
            state.isInsuranceLoading = false;
        },
        setInsuranceLoading: (state, action) => {
            state.isInsuranceLoading = action.payload;
        },
        setInsuranceLogged: (state, action) => {
            state.isInsuranceLogged = action.payload;
        },
        setInsurancePopupOpen: (state, action) => {
            state.isInsurancePopupOpen = action.payload;
        },
        setTotalPrice: (state, action) => {
            state.totalPrice = action.payload;
        },
        addRemoveToTotalPrice: (state, action) => {
            state.totalPrice = state.totalPrice + action.payload;
        },
        setTotalDiscount: (state, action) => {
            state.totalDiscount = action.payload;
        },
        addRemoveToTotalDiscount: (state, action) => {
            state.totalDiscount = state.totalDiscount + action.payload;
        },
        setSelectedColorOption: (state, action) => {
            state.selectedColorOption = action.payload;
        },
        setEditColorLens: (state, action) => {
            state.editColorLens = action.payload;
        },
        setFirstStep: (state, action) => {
            state.firstStep = action.payload;
        },
        openLearnMore: (state, action) => {
            state.typeLearnMore = action.payload;
        },
        closeLearnMore: (state, action) => {
            state.typeLearnMore = null;
        },
        setEditModeCatEntryId: (state, action) => {
            //if null --> no edit mode
            //if not null --> edit mode --> value should be lens catEntryId
            state.editModeCatEntryId = action.payload;
        },
        setEditModeWarrantyCatEntryId: (state, action) => {
            //if null --> no edit mode
            //if not null --> edit mode --> value should be warranty catEntryId
            state.editModeWarrantyCatEntryId = action.payload;
        },
        setEditModeRemoveWarrantyCatEntryId: (state, action) => {
            //if not null and editMode --> warranty has to be removed
            state.editModeRemoveWarrantyCatEntryId = action.payload;
        },
        setExtraTreatment: (state, action) => {
            state.extraTreatment = action.payload;
        },
        resetState: state => {
            let tempInitialState = utils.deepCopy(initialState);
            tempInitialState.data = state.data;
            tempInitialState.frameUPC = state.frameUPC;
            return tempInitialState;
        },
        setSelectedWarranty: (state, action) => {
            state.selectedWarranty = action.payload;
        },
        setIsAddingToCart: (state, action) => {
            state.isAddingToCart = action.payload;
        },
        openLearnMoreModal: (state, action) => {
            state.isLearnMoreModalOpen = true;
            state.treatmentTypeLearnMore = action.payload.treatmentTypeLearnMore;
            state.treatmentGroupLearnMore = action.payload.treatmentGroupLearnMore;
        },
        closeLearnMoreModal: (state, action) => {
            state.isLearnMoreModalOpen = false;
            state.treatmentTypeLearnMore = null;
            state.treatmentGroupLearnMore = null;
            state.espotBackground = null;
            state.espotBackgroundTreatment = null;
            state.contentOnLoad = null;
            state.controlVideo = null;
            state.fiveSecond = false;
            state.isMade = true;
            state.stepValueSelected = {};
            state.fullscreen = false;
            state.myVideoTime = null;
        },
        setStepValueSelected: (state, action) => {
            state.stepValueSelected = {};
            state.stepValueSelected = action.payload;
        },
        setForceTreatmentType: (state, action) => {
            state.forceTreatmentType = action.payload;
        },
        cleanForceTreatmentType: (state, action) => {
            state.forceTreatmentType = null;
        },
        setBaseLensPackage: (state, action) => {
            state.baseLensPackage = action.payload;
        },
        setEspotBackground: (state, action) => {
            state.espotBackground = action.payload;
        },
        setBlueLightAlertContent: (state, action) => {
            state.blueLightAlertContent = action.payload;
        },
        setGoToTreatment: (state, action) => {
            state.currentTreatment = action.payload.key;
            state.currentTreatmentSelected = action.payload.value;
        },
        setIsLensGaming: (state, action) => {
            state.isLensGaming = action.payload;
        },
        setBlueLightGamingAlertContent: (state, action) => {
            state.blueLightGamingAlertContent = action.payload;
        },
        setIsMade: (state, action) => {
            state.isMade = action.payload;
            state.fullscreen = false;
        },
        setEspotBackgroundTreatment: (state, action) => {
            state.espotBackgroundTreatment = action.payload;
        },
        setLabels: (state, action) => {
            state.labels = action.payload;
        },
        setBaseURLs: (state, action) => {
            state.baseURLs = action.payload;
            state.isReadyCustomURL = true;
        },
        setIsReadyCustomURL: (state, action) => {
            state.isReadyCustomURL = action.payload;
        },
        setProductImage: (state, action) => {
            state.productImage = action.payload;
        },
        setFiveSecond: (state, action) => {
            state.fiveSecond = action.payload;
        },
        setControlVideo: (state, action) => {
            state.controlVideo = action.payload;
        },
        setPercentageProgress: (state, action) => {
            state.percentageProgress = action.payload;
        },
        setLearnMoreBackgrounds: (state, action) => {
            state.learnMoreBackgrounds = action.payload;
        },
        setContentOnLoad: (state, action) => {
            state.contentOnLoad = action.payload;
        },
        setAnimationInsurance: (state, action) => {
            state.animationInsurance = action.payload;
        },
        setBrandDisclaimer: (state, action) => {
            state.brandDisclaimer = action.payload;
        },
        setBlueDisclaimer: (state, action) => {
            state.blueDisclaimer = action.payload;
        },
        setBrandSelected: (state, action) => {
            state.brandSelected = action.payload;
        },
        setFrameUPC: (state, action) => {
            state.frameUPC = action.payload;
        },
        setResetTotalsOnInit: (state, action) => {
            state.resetTotalsOnInit = action.payload;
        },
        setFullscreen: (state, action) => {
            state.fullscreen = action.payload;
        },
        setExtPrescriptionObject: (state, action) => {
            state.extPrescriptionObject = action.payload;
        },
        setSelectedPrescriptionObject: (state, action) => {
            state.selectedPrescriptionObject = action.payload;
        },
        setIsPrescriptionModalOpen: (state, action) => {
            state.isPrescriptionModalOpen = action.payload;
        },
        setIsSimplePrescription: (state, action) => {
            //if TRUE = simple prescription
            //if FALSE = full prescription
            state.isSimplePrescription = action.payload;
        },
        setCurrencyFormat: (state, action) => {
            state.currencyFormat = action.payload;
        },
        setIsPDModalOpen: (state, action) => {
            state.isPDModalOpen = action.payload;
        },
        setPDEspotContent: (state, action) => {
            state.pDEspotContent = action.payload;
        },
        setPrescriptionSidebarEspotContent: (state, action) => {
            state.prescriptionSidebarEspotContent = action.payload;
        },
        setMirrorAlertContent: (state, action) => {
            state.mirrorAlertContent = action.payload;
        },
        setPaymentInstallmentsType: (state, action) => {
            state.paymentInstallmentsType = action.payload;
        },
        setPaymentInstallmentsQuantity: (state, action) => {
            state.paymentInstallmentsQuantity = action.payload;
        },
        setTapAndHold: (state, action) => {
            state.tapAndHold = action.payload;
        },
        setEspotBackgroundTap: (state, action) => {
            state.espotBackgroundTap = action.payload;
        },
        setEspotBackgroundTreatmentTap: (state, action) => {
            state.espotBackgroundTreatmentTap = action.payload;
        },
        setIsMoreOneBrand: (state, action) => {
            state.isMoreOneBrand = action.payload;
        },
        setProductImageOld: (state, action) => {
            state.productImageOld = action.payload;
        },
        setIsPrescriptionFormOpen: (state, action) => {
            state.isPrescriptionFormOpen = action.payload;
        },
        setIsFrameOnlySelected: (state, action) => {
            state.isFrameOnlySelected = action.payload;
        },
        setMyVideoTime: (state, action) => {
            state.myVideoTime = action.payload;
        },
        setIsGVP: (state, action) => {
            state.isGVP = action.payload;
        },
        setIsFirstVideo: (state, action) => {
            state.isFirstVideo = action.payload;
        },
        setImageErrorMessage: (state, action) => {
            state.imageErrorMessage = action.payload;
        },
        setEspotBackgroundVideo: (state, action) => {
            state.espotBackgroundVideo = action.payload;
        },
        setErrorLoadImage: (state, action) => {
            state.errorLoadImage = action.payload;
        },
        setLensErrorMessage: (state, action) => {
            state.lensErrorMessage = action.payload;
        },
    },
});

export const {
    setData,
    setSelectedOptions,
    clearSelectedOptions,
    setSelectedPackage,
    clearSelectedPackage,
    setTreatmentOptions,
    setTreatmentOptionsPackages,
    setTreatmentStepTitleInGvp,
    goToStep,
    openExitModal,
    closeExitModal,
    setInsuranceEnabled,
    setInsuranceLoading,
    setInsuranceLogged,
    setInsurancePopupOpen,
    setTotalPrice,
    addRemoveToTotalPrice,
    setTotalDiscount,
    addRemoveToTotalDiscount,
    setSelectedColorOption,
    setEditColorLens,
    setFirstStep,
    openLearnMore,
    closeLearnMore,
    setEditModeCatEntryId,
    setEditModeWarrantyCatEntryId,
    setEditModeRemoveWarrantyCatEntryId,
    setExtraTreatment,
    resetState,
    setIsAddingToCart,
    setSelectedWarranty,
    openLearnMoreModal,
    closeLearnMoreModal,
    setStepValueSelected,
    setForceTreatmentType,
    cleanForceTreatmentType,
    setBaseLensPackage,
    setEspotBackground,
    setBlueLightAlertContent,
    setGoToTreatment,
    setIsLensGaming,
    setBlueLightGamingAlertContent,
    setIsMade,
    setEspotBackgroundTreatment,
    setLabels,
    setBaseURLs,
    setIsReadyCustomURL,
    setProductImage,
    setFiveSecond,
    setControlVideo,
    setPercentageProgress,
    setLearnMoreBackgrounds,
    setContentOnLoad,
    setAnimationInsurance,
    setBrandDisclaimer,
    setBlueDisclaimer,
    setBrandSelected,
    setFrameUPC,
    setResetTotalsOnInit,
    setFullscreen,
    setExtPrescriptionObject,
    setSelectedPrescriptionObject,
    setIsPrescriptionModalOpen,
    setIsSimplePrescription,
    setCurrencyFormat,
    setPDEspotContent,
    setIsPDModalOpen,
    setPrescriptionSidebarEspotContent,
    setMirrorAlertContent,
    setPaymentInstallmentsType,
    setPaymentInstallmentsQuantity,
    setTapAndHold,
    setEspotBackgroundTap,
    setEspotBackgroundTreatmentTap,
    setIsMoreOneBrand,
    setProductImageOld,
    setIsPrescriptionFormOpen,
    setIsFrameOnlySelected,
    setMyVideoTime,
    setIsGVP,
    setIsFirstVideo,
    setImageErrorMessage,
    setEspotBackgroundVideo,
    setErrorLoadImage,
    setLensErrorMessage,
} = mainSlice.actions;

export default mainSlice.reducer;
